
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

export default function ContactSection() {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section
      id="kontakt"
      ref={ref}
      className="relative py-16 sm:py-24 lg:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(#00E5FF 1px, transparent 1px), linear-gradient(90deg, #00E5FF 1px, transparent 1px)',
            backgroundSize: '50px 50px',
          }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
          className="text-center mb-10 sm:mb-16 lg:mb-20"
        >
          <span
            className="text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Kontakt
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 sm:mt-4 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Rozpocznij <span className="text-[#00E5FF]">Współpracę</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}
            className="space-y-4 sm:space-y-6 lg:space-y-8"
          >
            {/* Lokalizacja */}
            <div className="bg-[#111111] border border-[#00E5FF]/20 p-5 sm:p-6 lg:p-8 hover:border-[#00E5FF] transition-all duration-300">
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="w-11 h-11 sm:w-14 sm:h-14 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF] flex-shrink-0">
                  <i className="ri-map-pin-line text-lg sm:text-2xl text-[#00E5FF]"></i>
                </div>
                <div>
                  <h3
                    className="text-lg sm:text-xl font-bold text-white mb-2 leading-tight"
                    style={{ fontFamily: 'Rajdhani, sans-serif' }}
                  >
                    Lokalizacja
                  </h3>
                  <p
                    className="text-[#C0C7CF] text-xs sm:text-sm"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    Przedsiębiorstwo Wielobranżowe EUREKA<br />
                    Zabłotce 146<br />
                    38-500 Sanok
                  </p>
                </div>
              </div>
            </div>

            {/* Telefon */}
            <div className="bg-[#111111] border border-[#00E5FF]/20 p-5 sm:p-6 lg:p-8 hover:border-[#00E5FF] transition-all duration-300">
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="w-11 h-11 sm:w-14 sm:h-14 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF] flex-shrink-0">
                  <i className="ri-phone-line text-lg sm:text-2xl text-[#00E5FF]"></i>
                </div>
                <div>
                  <h3
                    className="text-lg sm:text-xl font-bold text-white mb-2 leading-tight"
                    style={{ fontFamily: 'Rajdhani, sans-serif' }}
                  >
                    Telefon
                  </h3>
                  <p
                    className="text-[#C0C7CF] text-xs sm:text-sm mb-2"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    <strong className="text-white">Janusz Gładysz</strong> - właściciel
                    <br />
                    <a
                      href="tel:+48600978050"
                      className="text-[#00E5FF] hover:underline cursor-pointer"
                    >
                      +48 600 978 050
                    </a>
                  </p>
                  <p
                    className="text-[#C0C7CF] text-xs sm:text-sm"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    <strong className="text-white">Konrad Komarski</strong> - kierownik produkcji
                    <br />
                    <a
                      href="tel:+48790788033"
                      className="text-[#00E5FF] hover:underline cursor-pointer"
                    >
                      +48 790 788 033
                    </a>
                  </p>
                  <p
                    className="text-[#C0C7CF] text-xs sm:text-sm mt-2"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    <a
                      href="tel:+48790333565"
                      className="text-[#00E5FF] hover:underline cursor-pointer"
                    >
                      +48 790 333 565
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="bg-[#111111] border border-[#00E5FF]/20 p-5 sm:p-6 lg:p-8 hover:border-[#00E5FF] transition-all duration-300">
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="w-11 h-11 sm:w-14 sm:h-14 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF] flex-shrink-0">
                  <i className="ri-mail-line text-lg sm:text-2xl text-[#00E5FF]"></i>
                </div>
                <div>
                  <h3
                    className="text-lg sm:text-xl font-bold text-white mb-2 leading-tight"
                    style={{ fontFamily: 'Rajdhani, sans-serif' }}
                  >
                    Email
                  </h3>
                  <p
                    className="text-[#C0C7CF] text-xs sm:text-sm"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    <a
                      href="mailto:jgladysz@eureka.sanok.pl"
                      className="text-[#00E5FF] hover:underline cursor-pointer"
                    >
                      jgladysz@eureka.sanok.pl
                    </a>
                    <br />
                    <a
                      href="mailto:kkomarski@eureka.sanok.pl"
                      className="text-[#00E5FF] hover:underline cursor-pointer"
                    >
                      kkomarski@eureka.sanok.pl
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.2 }}
            className="h-[300px] sm:h-[400px] lg:h-[600px] bg-[#111111] border border-[#00E5FF]/20"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d5174.619907054426!2d22.15103863108019!3d49.57304199999759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sEureka%20Zab%C5%82otce%20146!5e0!3m2!1spl!2spl!4v1601300423205!5m2!1spl!2spl"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="EUREKA Lokalizacja"
            ></iframe>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
